import { render, staticRenderFns } from "./ModalFormularioAprobarSolicitudInscripcion.vue?vue&type=template&id=c14f0b60&scoped=true"
import script from "./ModalFormularioAprobarSolicitudInscripcion.vue?vue&type=script&lang=js"
export * from "./ModalFormularioAprobarSolicitudInscripcion.vue?vue&type=script&lang=js"
import style0 from "./ModalFormularioAprobarSolicitudInscripcion.vue?vue&type=style&index=0&id=c14f0b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c14f0b60",
  null
  
)

export default component.exports